import styled from 'styled-components'
import { ImportAndExportIcon, ImportAndExportIconButton } from '../styles'

const ExportIconButton = styled(ImportAndExportIconButton)``

const ExportIcon = styled(ImportAndExportIcon)``

export { ExportIconButton, ExportIcon }
